import type { Agent } from "@/types/aiToolkit";
import type { AgentChatHandoffPermissions } from "@/types/agentHandoff";

export function getChatHandoffPermissions(
  agent: Agent | null | undefined
): AgentChatHandoffPermissions | null {
  if (!agent?.actionPermissions) return null;
  const raw = agent.actionPermissions.chatHandoff;
  if (!raw || typeof raw !== "object") return null;
  const p = raw as AgentChatHandoffPermissions;
  return p.enabled ? p : null;
}

export function agentAllowsChatHandoff(agent: Agent | null | undefined): boolean {
  return Boolean(getChatHandoffPermissions(agent)?.enabled);
}

export function agentAllowsResume(agent: Agent | null | undefined): boolean {
  const p = getChatHandoffPermissions(agent);
  return Boolean(p?.enabled && p.allowResume !== false);
}

export const DEFAULT_CHAT_HANDOFF: AgentChatHandoffPermissions = {
  enabled: true,
  includeSourceContent: true,
  includeAgentOutput: true,
  allowResume: true,
  autoIndexForRag: false,
};
